/* eslint-disable import-x/no-default-export */
export default () => ({
  __typename: 'RightToWorkCredential',
});
